import React from "react";
import styles from "./TopNav.module.css";
import { useMenu } from "../../context/MenuContext";
import { useNavigate } from "react-router-dom";

/* ---------------- Menu Icon ---------------- */

function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
      <path
        d="M4 7h16M4 12h16M4 17h16"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/* ---------------- Back Icon ---------------- */

function BackIcon() {
  return (
    <svg viewBox="0 0 24 24" className={styles.icon} aria-hidden="true">
      <path
        d="M15 6l-6 6 6 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/* ---------------- Action Button ---------------- */

function ActionButton({ onClick, children, label }) {
  return (
    <button
      type="button"
      className={styles.actionButton}
      onClick={onClick}
      aria-label={label}
    >
      {children}
    </button>
  );
}

/* ---------------- Top Navigation ---------------- */

export default function TopNav({
  title,
  mode = "main",
  onMenuClick,
  onBackClick,
  rightAction = null,
  sticky = true,
  className = "",
}) {
  const isMain = mode === "main";
  const navigate = useNavigate();
  const { openMenu } = useMenu() || {};

  const handleTitleClick = () => {
    const role = String(localStorage.getItem("role") || "").toLowerCase();

    if (role === "admin") {
      navigate("/admin");
      return;
    }

    if (role === "payer") {
      navigate("/payer");
      return;
    }

    if (role === "vendor") {
      navigate("/vendor");
      return;
    }

    navigate("/");
  };

  const leftButton = isMain ? (
    <ActionButton onClick={onMenuClick || openMenu} label="Open menu">
      <MenuIcon />
    </ActionButton>
  ) : (
    <ActionButton onClick={onBackClick} label="Go back">
      <BackIcon />
    </ActionButton>
  );

  return (
    <header
      className={[
        styles.topNav,
        sticky ? styles.sticky : "",
        className,
      ].join(" ")}
    >
      <div className={styles.safeArea} />

      <div className={styles.inner}>
        <div className={styles.side}>{leftButton}</div>

        <div className={styles.center}>
          <h1
            className={styles.title}
            onClick={handleTitleClick}
            style={{ cursor: "pointer" }}
          >
            {title}
          </h1>
        </div>

        <div className={styles.side}>
          {rightAction ? (
            rightAction
          ) : (
            <div className={styles.placeholder} aria-hidden="true" />
          )}
        </div>
      </div>
    </header>
  );
}